'use client';

import { FC } from 'react';

export enum IconButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WARNING = 'warning',
  ERROR = 'error',
}

export interface IconButtonProps {
  text: string;
  icon?: string;
  type?: "button" | "submit" | "reset" | undefined;
  classes?: string;
  disabled?: boolean;
  onClick?: () => void;
  color?: IconButtonTypes;
}

const IconButton: FC<IconButtonProps> = ({
  text,
  icon,
  classes,
  type,
  onClick,
  disabled,
  color
}) => {
  const getButtonType = () => {
    switch (color) {
      case IconButtonTypes.PRIMARY:
        return 'bg-[#0E282F] text-white'
      default:
        return 'bg-transparent text-[#020817] border border-[#E2E8F0] hover:bg-[#F2F2F2] transition-all'
    }
  }
  return (
    <button
      type={type ? type : 'button'}
      onClick={() => onClick && onClick()}
      className={
        `${getButtonType()} h-[38px] inline-flex items-center justify-center text-[14px]
        rounded-md px-3 ${classes} ${disabled && 'opacity-30'}
      `}
      disabled={disabled}
    >
      {icon && <i className={`icon-${icon} text-[14px] mr-2`}></i>}
      <span>{text}</span>
    </button>
  );
};

export default IconButton;
